export const VENTAS_DOCUMENT_TYPES = [
  { value: 'factura', label: 'Factura' },
  { value: 'boleta', label: 'Boleta' },
  { value: 'otro', label: 'Otro documento' },
];

export const VENTAS_PAYMENT_METHODS = [
  { value: 'efectivo', label: 'Efectivo' },
  { value: 'transferencia', label: 'Transferencia' },
  { value: 'yape', label: 'Yape' },
  { value: 'plin', label: 'Plin' },
  { value: 'otro', label: 'Otro' },
];

/** Medios digitales que requieren número de operación. */
export const VENTAS_PAYMENT_METHODS_WITH_OPERATION = ['transferencia', 'yape', 'plin'];

export const ventasPaymentMethodNeedsOperation = (value) =>
  VENTAS_PAYMENT_METHODS_WITH_OPERATION.includes(value);

export const getVentasDocumentTypeLabel = (value) =>
  VENTAS_DOCUMENT_TYPES.find((opt) => opt.value === value)?.label || value || '—';

export const getVentasPaymentMethodLabel = (value) =>
  VENTAS_PAYMENT_METHODS.find((opt) => opt.value === value)?.label || value || '—';
